import { NgModule } from '@angular/core';
//components
import { AppComponent } from 'src/app/app.component';
import { ToastComponent } from './core/components/toasts.component';
//Module
import { AppRoutingModule } from 'src/app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'src/app/core/core.module';
// store state
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from 'src/app/states';
import { EnumService } from './shared/services/http/settings/setting.service';
import { EditTableComponent } from './pages/station/edit-table/edit-table.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppComponent, ToastComponent, EditTableComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    NgbToastModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    NgMultiSelectDropDownModule,
    ReactiveFormsModule,
  ],
  bootstrap: [AppComponent],
  providers: [EnumService],
})
export class AppModule {}
